import React from "react";
import Sidebar from "./Sidebar";
import ChatWindow from "./ChatWindow";


const AiAgent = () => {
  
  return (
    <main className="bg-[#EBF3FF] text-[#282F40] h-screen w-screen flex">
      {/* <Sidebar /> */}
      <ChatWindow />
      
    </main>
  );
};

export default AiAgent;
